
// export const myAction = ( state ) => {

// }

export const saveUser = ( state, user ) => {
    state.user = user
}
